<template>
    <div class="sidebar d-flex align-items-end relative alt">

        <img class="smallLogo" src="/static/images/common/logo_small_red_white.svg">

        <img class="img-fluid" src="/static/images/auth/signup.jpg">

        <div class="text">
            <div v-if="typeSentence" class="fs-small dark">{{ typeSentence }}</div>
            <div class="fs-largest lightest headline">"We can turn our effort into creating better experiences to our customers."</div>
            <div class="fs-small dark">No booking fees for unlimited products and unlimited agents.</div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters([
                'accountSetup',
            ]),
            typeSentence: function() {
                if (this.accountSetup.type !== undefined) {
                    return (this.accountSetup.type === 'agent') ? 'I am an agent' : 'I am a service supplier';
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    .smallLogo{
        width: 31px;
        position: absolute;
        top: 20px;
        left: 20px;
    }
</style>



// WEBPACK FOOTER //
// SignupSidebar.vue?5c4f9ac2